import HTTPClient from './http-client';
import { createUrl } from "../utils_functions";
const END_POINT = '/monthlysummary';

const options = {
  cache: {
      maxAge: 15 * 60 * 1000,
      exclude: { query: false }
  }
}

const loadMonthlySummary = async ({ date_end, date_start, operation_ids, organization_ids, sensor_ids, sort, station_ids, stationtype_ids }) => {
  const httpClient = new HTTPClient();
  const api = await httpClient.configure();
  const url = createUrl(END_POINT, { date_end, date_start, operation_ids, organization_ids, sensor_ids, sort, station_ids, stationtype_ids });
  return api.get(url, options);
}

export {
  loadMonthlySummary,
}
